import "nabla:shell";
import "./design/tokens.css";
import "./design/global.css";
import "./shell/navigation/zoom.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { browserClient, ClientProvider } from "./client/index.ts";
import { entrypoints, slots } from "./features/index.ts";
import { modulePlaces } from "./shell/navigation/module-places.ts";
import { compileRoutes } from "./shell/navigation/router.ts";
import { Shell } from "./shell/Shell.tsx";

new Worker(NABLA_WORKER);

const app = document.getElementById("app");
if (!app) throw new Error("index.html has no #app element");

const root = createRoot(app);
const routes = compileRoutes([...entrypoints, ...modulePlaces()]);
const { client, actions } = browserClient();
const first = routes.match(`${location.pathname}${location.search}`);
if (first?.entry.public !== true) client.start();
void first?.entry.open(first.params, first.query).load(client).catch(() => undefined);
root.render(
  <StrictMode>
    <ClientProvider client={client} actions={actions}>
      <Shell routes={routes} slots={slots} />
    </ClientProvider>
  </StrictMode>,
);
